import React, { useCallback, useEffect, useRef, useState } from 'react';

import SignaturePad from 'signature_pad';

import { FaEraser } from 'react-icons/fa';

import { SignatureContainer, Canvas, Buttons, ButtonClear } from './styles';

type ComponentProps = {
  handleAssinar(assinatura: string): void;
  disabled?: boolean;
};

const AssinaturaDigital: React.FC<ComponentProps> = ({
  handleAssinar,
  disabled = false,
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const signaturePadRef = useRef<SignaturePad | undefined>(undefined);
  const [assinou, setAssinou] = useState(false);

  const redimensionaCanvas = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d')?.scale(ratio, ratio);

    signaturePadRef.current?.clear();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    let signaturePad: SignaturePad | undefined;

    if (canvas) {
      signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgba(255,255,255,0)',
        penColor: '#000000',
        onEnd: () => {
          if (signaturePad) setAssinou(!signaturePad.isEmpty());
        },
      });
      signaturePadRef.current = signaturePad;
    }

    redimensionaCanvas();

    window.addEventListener('resize', redimensionaCanvas);
    return () => {
      window.removeEventListener('resize', redimensionaCanvas);
      signaturePad?.off();
    };
  }, [redimensionaCanvas]);

  const handleLimpar = useCallback(() => {
    signaturePadRef.current?.clear();
    setAssinou(false);
  }, []);

  const handleConfirmar = useCallback(() => {
    const signaturePad = signaturePadRef.current;

    if (!signaturePad || signaturePad.isEmpty()) return;

    handleAssinar(signaturePad.toDataURL('image/png'));
  }, [handleAssinar]);

  return (
    <SignatureContainer>
      <Canvas ref={canvasRef} />
      <Buttons>
        <ButtonClear
          type="button"
          onClick={handleConfirmar}
          disabled={disabled || !assinou}
        >
          Assinar contrato
        </ButtonClear>
        <ButtonClear type="button" onClick={handleLimpar} disabled={disabled}>
          <FaEraser /> Limpar
        </ButtonClear>
      </Buttons>
    </SignatureContainer>
  );
};

export default AssinaturaDigital;
